module.exports = __webpack_public_path__ + "static/media/1004364.10677240.png";